import Step1 from "../Steps/Step1";
import Step2 from "../Steps/Step2";
import Step3 from "../Steps/Step3";

export const PHOTO_VERIFICATION_STEPS = [
  {
    key: "driver_photo",
    component: Step1,
  },
  {
    key: "impersonation",
    component: Step2,
  },
  {
    key: "device_linkages",
    component: Step3,
  },
];
